import React, { useContext, useState, useEffect } from 'react';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/SearchResults/index.constant';
import { SearchFilterContext } from '../../organisms/SearchResults/index.context';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { StyledEventsFilterDiv } from './index.styles';
import { CheckBox, checkboxVariation } from '@marriott/mi-ui-library';
import { useWindowSize } from '../../hooks';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';
import { formatNumberByLocale } from '../../utils';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { usePageContext } from '../../context/PageContext/index';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const EventsFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  eventsList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, eventsList }) => {
  const { searchQueryState } = useContext(SearchFilterContext);
  const { currentLocale } = usePageContext();
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';
  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.meetingEvents]
  );
  const { width } = useWindowSize();
  const getCurrEventTypes = (): SearchFacetsResponse =>
    eventsList
      ? eventsList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes?.meetingEvents)[0];

  const [eventTypes, setEventTypes] = useState<SearchFacetsResponse>(getCurrEventTypes());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectionChange = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.meetingEvents, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, events: true });
  };

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);

  useEffect(() => {
    setEventTypes(getCurrEventTypes());
  }, [eventsList]);

  return eventTypes?.type?.count ? (
    <StyledEventsFilterDiv className="t-font-alt-m hotel-types-filters-container">
      <fieldset>
        <div className="t-font-alt-m filter-heading-container">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {eventTypes?.type?.label}
            </h4>
          </legend>
        </div>
        <StyledCheckboxItemsContainer>
          {eventTypes?.buckets?.map((eventType: SearchFacetsResponseBuckets, idx: number) => (
            <StyledCheckboxItemDiv className="m-checkbox-selection-item hotel-type-description" key={idx}>
              <CheckBox
                variation={checkboxVariation.SIMPLE}
                className=""
                checkboxId={`events-${eventType?.code}-checkbox`}
                checkboxName="event_filter_checkbox"
                onChange={(e): void => onSelectionChange(e, eventType)}
                onKeyDown={(e): void => onSelectionChange(e, eventType)}
                checked={currSelectedItem ? eventType.code in currSelectedItem === true : false}
                inputClassName="checkbox-input custom_click_track"
                setTabIndex={-1}
                children={
                  <>
                    <span className="t-font-s">{eventType?.label}</span>
                    {eventType?.count && (
                      <span className="t-font-s pl-1">({formatNumberByLocale(eventType?.count, currentLocale)})</span>
                    )}
                  </>
                }
                {...{ custom_click_track_value: `${clickTrackingLoc}| Event type: ${eventType?.label} |internal` }}
              />
            </StyledCheckboxItemDiv>
          ))}
        </StyledCheckboxItemsContainer>
      </fieldset>
      <hr aria-hidden className="filter-separator" />
    </StyledEventsFilterDiv>
  ) : null;
};
